import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { getOrgId } from "utils";

import Paths from "./paths";
import * as Types from "./types";

export const workLevelListService = (params: Types.WorkLevelListRequest) =>
  RestAPIClient.call<Types.WorkLevelListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const workLevelListShortService = (params: Types.WorkLevelListRequest) =>
  RestAPIClient.call<Types.WorkLevelListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const workLevelCreateService = (params: Types.WorkLevelCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{OrgId}", getOrgId()),
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const workLevelUpdateService = (params: Types.WorkLevelUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace("{OrgId}", getOrgId())}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const workLevelDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update.replace("{OrgId}", getOrgId())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const workLevelDetailService = (id: string) =>
  RestAPIClient.call<Types.WorkLevelDetail>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update.replace("{OrgId}", getOrgId())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
